"use strict";

angular.module('rmRundown')
    .factory('Item', require('./item.js'))
    .factory('UserFilters', require('./userfilters.js'));